module.exports = __webpack_public_path__ + "img/Path 20@3x.5b8cf2d9.png";